var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { staticClass: "stretched policy-container" },
    [
      _c("div", { attrs: { id: "wrapper" } }, [
        _c(
          "div",
          {
            class:
              "container " +
              (_vm.$vuetify.breakpoint.xsOnly ? "pt-4 px-4 mb-2" : "pt-3 mb-6"),
          },
          [
            _c(
              "div",
              { staticClass: "d-inline-flex w-100 justify-content-start" },
              [
                _c(
                  "div",
                  { staticClass: "d-inline-flex w-50 align-items-center" },
                  [
                    _c(
                      "router-link",
                      { staticClass: "policy-back-link", attrs: { to: "/" } },
                      [
                        _c("img", {
                          attrs: {
                            src: "/content/svgs/arrow-back.svg",
                            alt: "back",
                          },
                        }),
                      ]
                    ),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "w-50 d-flex justify-content-end",
                    attrs: { id: "logo" },
                  },
                  [
                    _c("router-link", { attrs: { to: "/" } }, [
                      _c("img", {
                        staticClass: "logo-default",
                        attrs: {
                          srcset: "/content/images/stemdo-black-logo.png",
                          src: "/content/images/stemdo-black-logo.png",
                          alt: "Stemdo Logo",
                        },
                      }),
                    ]),
                  ],
                  1
                ),
              ]
            ),
          ]
        ),
        _vm._v(" "),
        _c(
          "section",
          {
            class: _vm.$vuetify.breakpoint.xsOnly ? "px-3" : "",
            attrs: { id: "content" },
          },
          [
            _c("div", { staticClass: "content-wrap" }, [
              _c("div", { staticClass: "container policy-content" }, [
                _c(
                  "h1",
                  { staticClass: "ppmountent text-main-color policy-title" },
                  [_vm._v("Política de Cookies")]
                ),
                _vm._v(" "),
                _vm._m(0),
                _vm._v(" "),
                _c("p", { staticClass: "text-dark-grey-color" }, [
                  _vm._v(
                    "\n            El objetivo de esta Política es informar a los Usuarios sobre qué son las Cookies, cómo se utilizan en el Sitio Web\n            y cómo el Usuario puede gestionar su instalación o uso. Con el fin de facilitar la navegación, STEMDO ECOSYSTEM S.L.\n            comunica al Usuario que utiliza Cookies u otros archivos de funcionalidad similar.\n          "
                  ),
                ]),
                _vm._v(" "),
                _c("p", { staticClass: "text-dark-grey-color" }, [
                  _vm._v(
                    "\n            En todo caso, STEMDO ECOSYSTEM S.L. es el responsable de dichas Cookies y del tratamiento de los datos obtenidos a\n            través de éstas, decidiendo sobre la finalidad, contenido y uso del tratamiento de la información recabada. El presente\n            Sitio Web no instalará Cookies no necesarias hasta que el Usuario haya otorgado su consentimiento.\n          "
                  ),
                ]),
                _vm._v(" "),
                _c("h2", [_vm._v("¿Cuál es la base legal?")]),
                _vm._v(" "),
                _c("p", { staticClass: "text-dark-grey-color" }, [
                  _vm._v(
                    "\n            Según la Ley 34/2002, de 11 de julio, de Servicios de la Sociedad de la Información y Comercio Electrónico, se informa\n            al Usuario de que este Sitio Web usa Cookies para mejorar y optimizar la experiencia del Usuario. A continuación,\n            encontrará información detallada sobre qué son las Cookies, qué tipología utiliza este Sitio Web, cómo cambiar la\n            configuración de sus Cookies, y qué ocurre si las deshabilita.\n          "
                  ),
                ]),
                _vm._v(" "),
                _c("h2", [_vm._v("¿Qué son las Cookies?")]),
                _vm._v(" "),
                _c("p", { staticClass: "text-dark-grey-color" }, [
                  _vm._v(
                    "\n            Una Cookie es un fichero que se descarga en el ordenador del Usuario al acceder a determinadas páginas web. Las Cookies\n            permiten a una página web, entre otras cosas, almacenar y recuperar información sobre los hábitos de navegación de un\n            Usuario o de su equipo y, dependiendo de la información que contengan y de la forma en que utilice su equipo, pueden\n            utilizarse para reconocer al Usuario.\n          "
                  ),
                ]),
                _vm._v(" "),
                _c("p", { staticClass: "text-dark-grey-color" }, [
                  _vm._v(
                    "\n            El uso de Cookies no necesarias estará sujeto al consentimiento previo del Usuario. Si se desactivan o se rechazan las\n            Cookies, puede que la navegación por el Sitio Web no sea óptima y que algunas de las funcionalidades disponibles no\n            funcionen correctamente. Las Cookies no necesarias se instalarán únicamente una vez el Usuario haya otorgado su\n            consentimiento.\n          "
                  ),
                ]),
                _vm._v(" "),
                _c("p", { staticClass: "text-dark-grey-color" }, [
                  _vm._v(
                    "\n            En esta Política de Cookies se informa de manera general de todas las Cookies utilizadas en el Sitio Web. Sin embargo,\n            las Cookies técnicas, necesarias para el funcionamiento del Sitio Web, no pueden ser desactivadas a través del panel de\n            configuración de cookies, sin perjuicio de que el Usuario pueda configurar su navegador para bloquearlas o eliminarlas.\n          "
                  ),
                ]),
                _vm._v(" "),
                _c("h2", [
                  _vm._v("¿Qué tipos de Cookies utiliza esta página web?"),
                ]),
                _vm._v(" "),
                _c("h3", [_vm._v("Por finalidad")]),
                _vm._v(" "),
                _vm._m(1),
                _vm._v(" "),
                _c("h3", [_vm._v("Por titularidad")]),
                _vm._v(" "),
                _vm._m(2),
                _vm._v(" "),
                _c("p", { staticClass: "text-dark-grey-color" }, [
                  _vm._v(
                    "\n            Este Sitio Web utiliza Cookies de terceros, en particular de proveedores como Google Analytics (Google LLC), HubSpot y\n            PostHog, que permiten analizar el comportamiento de los Usuarios en el Sitio Web y mejorar los servicios ofrecidos.\n          "
                  ),
                ]),
                _vm._v(" "),
                _c("p", { staticClass: "text-dark-grey-color" }, [
                  _vm._v(
                    "\n            La información recogida mediante estas Cookies puede ser transferida a terceros países, en particular a Estados Unidos\n            u otros países donde se ubiquen los servidores de dichos proveedores. Estas transferencias internacionales de datos se\n            realizan de conformidad con el Reglamento General de Protección de Datos, mediante cláusulas contractuales tipo\n            aprobadas por la Comisión Europea.\n          "
                  ),
                ]),
                _vm._v(" "),
                _c("p", { staticClass: "text-dark-grey-color" }, [
                  _vm._v(
                    "El Usuario puede obtener más información en las políticas de privacidad de cada proveedor:"
                  ),
                ]),
                _vm._v(" "),
                _vm._m(3),
                _vm._v(" "),
                _vm._m(4),
                _vm._v(" "),
                _c("h2", [
                  _vm._v("¿Qué ocurre si se deshabilitan las Cookies?"),
                ]),
                _vm._v(" "),
                _c("p", { staticClass: "text-dark-grey-color" }, [
                  _vm._v(
                    "\n            Desactivar o bloquear las Cookies puede afectar al funcionamiento de nuestros servicios y Sitios Web, resultando en\n            una experiencia menos satisfactoria. Sin embargo, el Usuario podrá ejercer en cualquier momento su derecho de\n            desactivación o eliminación de Cookies modificando la configuración de las opciones del navegador instalado en su\n            ordenador.\n          "
                  ),
                ]),
                _vm._v(" "),
                _c("h2", [
                  _vm._v("¿Actualizamos nuestra Política de Cookies?"),
                ]),
                _vm._v(" "),
                _c("p", { staticClass: "text-dark-grey-color" }, [
                  _vm._v(
                    "\n            La presente Política de Cookies podrá ser actualizada cuando resulte necesario, ya sea por cambios normativos, por\n            modificaciones en las Cookies utilizadas o por adaptación a las instrucciones de las autoridades de control, como la\n            Agencia Española de Protección de Datos. Se recomienda al Usuario revisar periódicamente esta política para estar\n            adecuadamente informado sobre el uso de cookies.\n          "
                  ),
                ]),
                _vm._v(" "),
                _c("h2", [_vm._v("¿Qué Cookies necesitan consentimiento?")]),
                _vm._v(" "),
                _c("p", { staticClass: "text-dark-grey-color" }, [
                  _vm._v(
                    "\n            Las Cookies técnicas, por ser necesarias para el funcionamiento del Sitio Web, no requieren el consentimiento del\n            Usuario. Las Cookies de análisis propios y de terceros se instalarán únicamente previo consentimiento del Usuario.\n          "
                  ),
                ]),
                _vm._v(" "),
                _c("h2", [
                  _vm._v(
                    "¿Cómo puede el Usuario configurar sus Cookies o retirar el consentimiento?"
                  ),
                ]),
                _vm._v(" "),
                _c("p", { staticClass: "text-dark-grey-color" }, [
                  _vm._v(
                    "\n            El uso de Cookies no necesarias para el funcionamiento del Sitio Web se encuentra sujeto al consentimiento previo del\n            Usuario. El consentimiento se obtendrá mediante una acción afirmativa clara por parte del Usuario, a través de un\n            sistema de gestión o panel de configuración de Cookies, que permitirá aceptar, rechazar o configurar el uso de estas\n            de forma granular. En ningún caso la mera navegación implicará la prestación del consentimiento.\n          "
                  ),
                ]),
                _vm._v(" "),
                _c("p", { staticClass: "text-dark-grey-color" }, [
                  _vm._v(
                    "\n            El Usuario podrá retirar su consentimiento en cualquier momento, con la misma facilidad con la que lo otorgó, a través\n            del panel de configuración de Cookies habilitado en el Sitio Web. La retirada del consentimiento no afectará a la\n            licitud del tratamiento basado en el consentimiento previo a su retirada.\n          "
                  ),
                ]),
                _vm._v(" "),
                _c("p", { staticClass: "text-dark-grey-color" }, [
                  _vm._v(
                    "\n            Las Cookies técnicas se instalarán automáticamente y no requieren el consentimiento del Usuario, de conformidad con\n            el artículo 22.2 de la Ley 34/2002, de 11 de julio, de servicios de la sociedad de la información y de comercio\n            electrónico.\n          "
                  ),
                ]),
                _vm._v(" "),
                _c("p", { staticClass: "text-dark-grey-color" }, [
                  _vm._v(
                    "\n            Asimismo, el Usuario puede ejercer en cualquier momento su derecho a bloquear, eliminar o configurar el uso de Cookies\n            mediante la modificación de las opciones de su navegador:\n          "
                  ),
                ]),
                _vm._v(" "),
                _vm._m(5),
                _vm._v(" "),
                _vm._m(6),
                _vm._v(" "),
                _c("h2", [_vm._v("Información de contacto")]),
                _vm._v(" "),
                _c(
                  "p",
                  { staticClass: "text-dark-grey-color" },
                  [
                    _vm._v(
                      "\n            Para poder ejercitar cualquiera de sus derechos en materia de protección de datos, así como para conocer los fines del\n            tratamiento, destinatarios, transferencias internacionales, plazos de conservación, derechos de los interesados y\n            existencia de decisiones automatizadas, el Usuario puede acceder a la\n            "
                    ),
                    _c("router-link", { attrs: { to: "/privacy" } }, [
                      _vm._v("Política de Privacidad"),
                    ]),
                    _vm._v(" de STEMDO ECOSYSTEM S.L.\n          "),
                  ],
                  1
                ),
                _vm._v(" "),
                _c("p", { staticClass: "text-dark-grey-color" }, [
                  _vm._v(
                    "\n            Esta Política de Cookies podría ser modificada en función de las exigencias legislativas o reglamentarias, o con la\n            finalidad de adaptarla a las instrucciones dictadas por la Agencia Española de Protección de Datos. Cuando se produzcan\n            cambios significativos, se comunicarán a los Usuarios a través de correo electrónico.\n          "
                  ),
                ]),
                _vm._v(" "),
                _vm._m(7),
                _vm._v(" "),
                _vm._m(8),
                _vm._v(" "),
                _vm._m(9),
              ]),
            ]),
          ]
        ),
        _vm._v(" "),
        _c("footer", { attrs: { id: "footer" } }, [
          _c("div", { attrs: { id: "copyrights" } }, [
            _c("div", { staticClass: "container" }, [
              _c("div", { staticClass: "row" }, [
                _vm._m(10),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "col-md-7 text-center copyright-links" },
                  [
                    _c(
                      "div",
                      { staticClass: "d-flex justify-content-around px-2" },
                      [
                        _c("router-link", { attrs: { to: "/privacy" } }, [
                          _c("u", [_vm._v("Política de privacidad")]),
                        ]),
                        _vm._v(" "),
                        _c("router-link", { attrs: { to: "/cookies" } }, [
                          _c("u", [_vm._v("Política de Cookies")]),
                        ]),
                        _vm._v(" "),
                        _c("router-link", { attrs: { to: "/legal" } }, [
                          _c("u", [_vm._v("Aviso Legal")]),
                        ]),
                        _vm._v(" "),
                        _c("router-link", { attrs: { to: "/contact" } }, [
                          _c("u", [_vm._v("Contacto")]),
                        ]),
                      ],
                      1
                    ),
                  ]
                ),
                _vm._v(" "),
                _vm._m(11),
              ]),
            ]),
          ]),
        ]),
      ]),
      _vm._v(" "),
      _c("SCookieBanner"),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c,
      _setup = _vm._self._setupProxy
    return _c("p", { staticClass: "text-dark-grey-color" }, [
      _vm._v(
        "\n            La presente Política de Cookies proporciona información a los Usuarios que navegan en el Sitio Web\n            "
      ),
      _c("a", { attrs: { href: "https://platform.stemdo.io/" } }, [
        _vm._v("https://platform.stemdo.io/"),
      ]),
      _vm._v(
        " sobre el uso por parte de STEMDO ECOSYSTEM S.L.\n            de Cookies y otras tecnologías de seguimiento similares que se instalan en los dispositivos de los Usuarios.\n          "
      ),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c,
      _setup = _vm._self._setupProxy
    return _c("ul", { staticClass: "text-dark-grey-color" }, [
      _c("li", [
        _c("strong", [_vm._v("Cookies técnicas:")]),
        _vm._v(
          " son necesarias para el funcionamiento del Sitio Web y no requieren el consentimiento\n              del Usuario. Se instalan automáticamente al acceder al Sitio Web.\n            "
        ),
      ]),
      _vm._v(" "),
      _c("li", [
        _c("strong", [_vm._v("Cookies de análisis:")]),
        _vm._v(
          " permiten cuantificar el número de Usuarios y realizar la medición y análisis\n              estadístico del uso que hacen los Usuarios del servicio ofrecido, analizando su navegación para mejorar la oferta de\n              productos o servicios.\n            "
        ),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c,
      _setup = _vm._self._setupProxy
    return _c("ul", { staticClass: "text-dark-grey-color" }, [
      _c("li", [
        _c("strong", [_vm._v("Cookies propias:")]),
        _vm._v(
          " son aquellas que se envían al dispositivo del Usuario desde un equipo o dominio\n              gestionado por el propio titular del Sitio Web.\n            "
        ),
      ]),
      _vm._v(" "),
      _c("li", [
        _c("strong", [_vm._v("Cookies de terceros:")]),
        _vm._v(
          " son aquellas que se envían al dispositivo del Usuario desde un equipo o dominio\n              gestionado por una entidad distinta del titular del Sitio Web, que trata los datos obtenidos a través de las Cookies.\n            "
        ),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c,
      _setup = _vm._self._setupProxy
    return _c("ul", { staticClass: "text-dark-grey-color" }, [
      _c("li", [
        _c("strong", [_vm._v("Google LLC:")]),
        _vm._v(" "),
        _c(
          "a",
          {
            attrs: {
              href: "https://policies.google.com/privacy",
              target: "_blank",
            },
          },
          [_vm._v("https://policies.google.com/privacy")]
        ),
      ]),
      _vm._v(" "),
      _c("li", [
        _c("strong", [_vm._v("HubSpot, Inc.:")]),
        _vm._v(" "),
        _c(
          "a",
          {
            attrs: {
              href: "https://legal.hubspot.com/privacy-policy",
              target: "_blank",
            },
          },
          [_vm._v("https://legal.hubspot.com/privacy-policy")]
        ),
      ]),
      _vm._v(" "),
      _c("li", [
        _c("strong", [_vm._v("PostHog, Inc.:")]),
        _vm._v(" "),
        _c(
          "a",
          { attrs: { href: "https://posthog.com/privacy", target: "_blank" } },
          [_vm._v("https://posthog.com/privacy")]
        ),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c,
      _setup = _vm._self._setupProxy
    return _c("div", { staticClass: "policy-table-wrapper" }, [
      _c("table", { staticClass: "policy-table" }, [
        _c("thead", [
          _c("tr", [
            _c("th", [_vm._v("Nombre")]),
            _vm._v(" "),
            _c("th", [_vm._v("Descripción / Finalidad")]),
            _vm._v(" "),
            _c("th", [_vm._v("Proveedor")]),
            _vm._v(" "),
            _c("th", [_vm._v("Caducidad")]),
            _vm._v(" "),
            _c("th", [_vm._v("Tipo")]),
          ]),
        ]),
        _vm._v(" "),
        _c("tbody", [
          _c("tr", [
            _c("td", [_c("strong", [_vm._v("_ga")])]),
            _vm._v(" "),
            _c("td", [
              _vm._v(
                "Distingue usuarios únicos y recopila información estadística sobre el uso del Sitio Web."
              ),
            ]),
            _vm._v(" "),
            _c("td", [_vm._v("Google LLC")]),
            _vm._v(" "),
            _c("td", [_vm._v("2 años")]),
            _vm._v(" "),
            _c("td", [_vm._v("Análisis")]),
          ]),
          _vm._v(" "),
          _c("tr", [
            _c("td", [_c("strong", [_vm._v("_ga_PG9XG1TL61")])]),
            _vm._v(" "),
            _c("td", [
              _vm._v(
                "Mantiene el estado de la sesión y permite obtener métricas de uso del Sitio Web mediante Google Analytics."
              ),
            ]),
            _vm._v(" "),
            _c("td", [_vm._v("Google LLC")]),
            _vm._v(" "),
            _c("td", [_vm._v("2 años")]),
            _vm._v(" "),
            _c("td", [_vm._v("Análisis")]),
          ]),
          _vm._v(" "),
          _c("tr", [
            _c("td", [_c("strong", [_vm._v("hubspotutk")])]),
            _vm._v(" "),
            _c("td", [
              _vm._v(
                "Identifica al visitante y permite analizar su interacción con el Sitio Web."
              ),
            ]),
            _vm._v(" "),
            _c("td", [_vm._v("HubSpot, Inc.")]),
            _vm._v(" "),
            _c("td", [_vm._v("6 meses")]),
            _vm._v(" "),
            _c("td", [_vm._v("Análisis / Marketing")]),
          ]),
          _vm._v(" "),
          _c("tr", [
            _c("td", [_c("strong", [_vm._v("_hstc")])]),
            _vm._v(" "),
            _c("td", [
              _vm._v(
                "Cookie principal de seguimiento de visitantes utilizada por HubSpot."
              ),
            ]),
            _vm._v(" "),
            _c("td", [_vm._v("HubSpot, Inc.")]),
            _vm._v(" "),
            _c("td", [_vm._v("6 meses")]),
            _vm._v(" "),
            _c("td", [_vm._v("Análisis / Marketing")]),
          ]),
          _vm._v(" "),
          _c("tr", [
            _c("td", [_c("strong", [_vm._v("ph_*_posthog")])]),
            _vm._v(" "),
            _c("td", [
              _vm._v(
                "Permite analizar el comportamiento y navegación de los Usuarios en el Sitio Web."
              ),
            ]),
            _vm._v(" "),
            _c("td", [_vm._v("PostHog, Inc.")]),
            _vm._v(" "),
            _c("td", [_vm._v("Variable")]),
            _vm._v(" "),
            _c("td", [_vm._v("Análisis")]),
          ]),
        ]),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c,
      _setup = _vm._self._setupProxy
    return _c("ul", { staticClass: "text-dark-grey-color" }, [
      _c("li", [
        _c("strong", [_vm._v("Microsoft Edge:")]),
        _vm._v(" Configuración > Configuración Avanzada > Cookies"),
      ]),
      _vm._v(" "),
      _c("li", [
        _c("strong", [_vm._v("Mozilla Firefox:")]),
        _vm._v(
          " Herramientas > Opciones > Privacidad > Historial > Configuración Personalizada"
        ),
      ]),
      _vm._v(" "),
      _c("li", [
        _c("strong", [_vm._v("Google Chrome:")]),
        _vm._v(
          " Configuración > Mostrar opciones avanzadas > Privacidad > Configuración de contenido"
        ),
      ]),
      _vm._v(" "),
      _c("li", [
        _c("strong", [_vm._v("Safari (Apple):")]),
        _vm._v(" Preferencias > Seguridad"),
      ]),
      _vm._v(" "),
      _c("li", [
        _c("strong", [_vm._v("Opera:")]),
        _vm._v(" Configuración > Opciones > Avanzado > Cookies"),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c,
      _setup = _vm._self._setupProxy
    return _c("p", { staticClass: "text-dark-grey-color" }, [
      _vm._v(
        "\n            Si el Usuario usa otro navegador, consulte su política de instalación, uso y bloqueo de Cookies. No obstante, usando la\n            herramienta "
      ),
      _c(
        "a",
        {
          attrs: {
            href: "https://www.youronlinechoices.com",
            target: "_blank",
          },
        },
        [_vm._v("www.youronlinechoices.com")]
      ),
      _vm._v(
        ", el Usuario podrá\n            encontrar información útil y configurar sus preferencias proveedor por proveedor.\n          "
      ),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c,
      _setup = _vm._self._setupProxy
    return _c("p", { staticClass: "text-dark-grey-color" }, [
      _vm._v(
        "\n            Si el Usuario desea más información, puede consultar la\n            "
      ),
      _c(
        "a",
        {
          attrs: {
            href: "https://www.aepd.es/guias/guia-cookies.pdf",
            target: "_blank",
          },
        },
        [_vm._v("Guía sobre el uso de cookies")]
      ),
      _vm._v(
        "\n            elaborada por la Agencia Española de Protección de Datos.\n          "
      ),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c,
      _setup = _vm._self._setupProxy
    return _c("p", { staticClass: "text-dark-grey-color" }, [
      _vm._v("\n            Para más información: "),
      _c("a", { attrs: { href: "mailto:dpd@stemdo.io" } }, [
        _vm._v("dpd@stemdo.io"),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c,
      _setup = _vm._self._setupProxy
    return _c("p", { staticClass: "text-dark-grey-color" }, [
      _c("strong", [_vm._v("Fecha de última actualización:")]),
      _vm._v(" 17 de mayo de 2026\n          "),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c,
      _setup = _vm._self._setupProxy
    return _c(
      "div",
      {
        staticClass: "col-md-3 text-center text-md-start",
        staticStyle: { color: "#606061" },
      },
      [_c("b", [_vm._v("Stemdo © 2024")])]
    )
  },
  function () {
    var _vm = this,
      _c = _vm._self._c,
      _setup = _vm._self._setupProxy
    return _c(
      "div",
      { staticClass: "col-md-2 text-center text-md-end pb-4 pb-sm-0" },
      [
        _c("div", { staticClass: "d-flex justify-content-around" }, [
          _c(
            "a",
            {
              attrs: {
                href: "https://www.instagram.com/stemdo_io/?hl=es",
                target: "_blank",
              },
            },
            [
              _c("img", {
                staticClass: "logo-default",
                attrs: {
                  src: "/content/images/instagram-icon.png",
                  alt: "Instagram icon",
                },
              }),
            ]
          ),
          _vm._v(" "),
          _c(
            "a",
            {
              attrs: {
                href: "https://www.linkedin.com/company/stemdo/",
                target: "_blank",
              },
            },
            [
              _c("img", {
                staticClass: "logo-default",
                attrs: {
                  src: "/content/images/linkedin-icon.png",
                  alt: "Linkedin icon",
                },
              }),
            ]
          ),
        ]),
      ]
    )
  },
]
render._withStripped = true

export { render, staticRenderFns }